import { BaseModalManager } from "./shared/BaseModalManager.js";

export default function showSelectedItems() {
  const isPresent = document.querySelector(".js-interior-modal");
  if (!isPresent) {
    return;
  }

  return new BaseModalManager({
    type: "items",
    triggerSelector: ".js-interior-modal",
    ajaxAction: "get_selected_items",
    dataKey: "selected_items",
    emptyMessage: "Siseviimistluses ei ole veel valikuid tehtud",
  });
}
